import {
  shape, arrayOf, oneOfType, string, number, any, bool, array,
} from 'prop-types';

export const descuentoCreacionType = shape({
  bonificacionVariable: shape({
    precioAlza: number,
    cantidad: number,
    tipo: string,
    id: number,
  }),
  bonificacionesEstaticas: array,
});

export const articuloCreacionType = shape({
  id: oneOfType([number, string]),
  descripcion: string,
  codigoTipo: number,
  pvp: number,

});

export const detalleCreacionType = shape({
  cdgtipo: number,
  cadenaTipo: string,
  linea: number,
  unidades: number,
  eliminable: bool,
  precio: number,
  articulo: articuloCreacionType,
  descuento: descuentoCreacionType,
  numeroLote: string,
});
export const graduacionesClienteCreacionType = shape({
  mostrar: bool,
  optometricas: shape({
    seleccion: shape({
      id: number,
      tiendaId: number,
    }),
    listado: array,
  }),
  contactologicas: shape({
    seleccion: shape({
      id: number,
      tiendaId: number,
    }),
    listado: array,
  }),
});

export const cabeceraEncargoCreacionType = shape({
  fechaCreacion: any,
  fechaCreacionPretty: string,
  fechaEntrega: any,
  tipoEncargoId: number,
  cliente: shape({
    id: number,
    nombreCompleto: string,
    tiendaId: number,
    graduaciones: graduacionesClienteCreacionType,
  }),
  motivoVisitaId: number,
  gestorId: number,
  numeroTalon: number,
  observaciones: string,
  tarjetaFidelizacion: shape({
    id: number,
    contenido: string,
  }),
});

export const encargoCreacionType = shape({
  id: number,
  expandido: bool,
  uuid: string.isRequired,
  nombre: string.isRequired,
  cabecera: cabeceraEncargoCreacionType,
  detalles: arrayOf(detalleCreacionType),
});

export const encargosCreacionTypes = arrayOf(encargoCreacionType);
